/*
  THIS COMPONENT IS NO LONGER USED
*/

import React, { useCallback, useContext, useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Tabs,
} from 'antd';
const FormItem = Form.Item;
const { Option } = Select;
const { TextArea } = Input;
const styles = {
  form: {
    width: '100%',
  },
  formItem: {
    paddingBottom: '0',
    marginBottom: '1rem',
  },
  summaryInput: {
    width: '425px',
  },
};
import ReferencesSelector, {
  EMPTY_ID,
} from '@totem/components/common/reference/ReferenceSelector';
import {
  MIN_DATE_TIME_STRING,
  Ticket,
  TicketCategory,
} from '@totem/components/ticketing/ticketing';
import { defaultTicket } from '@totem/components/ticketing/utilities';
import ModalFooter from '@totem/components/ui_components/dialogs/ModalFooter';
import ModalTitle from '@totem/components/ui_components/dialogs/ModalTitle';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { emptyId } from '@totem/components/userContext/security/userUtilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { ForeignKey, Reference } from '@totem/types/common';
import { isNotNull } from '@totem/utilities/common';
import { controlSystemTypeOptions } from '@totem/utilities/controlSystemsUtilities';
import { TICKET_ENDPOINT } from '@totem/utilities/endpoints';
export interface Props {
  regionId?: string;
  buildingId?: string;
  controlSystemId?: string;
  deviceId?: string;
  keys?: ForeignKey[];
  visible: boolean;
  onClose: (ticketCreated: boolean) => void;
  defaultSummary?: string;
  defaultDescription?: string;
  defaultCategory?: string;
  defaultSubCategory?: string;
}
const defaultTicketType: string = 'Service Request';
const TicketCreateModal = ({
  visible,
  onClose,
  regionId,
  buildingId,
  controlSystemId,
  deviceId,
  defaultSummary,
  defaultDescription,
  defaultCategory,
  defaultSubCategory,
  keys,
}: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [projectControlSystemType, setProjectControlSystemType] =
    useState<string>('');
  const [isSending, setIsSending] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [ticketCategories, setTicketCategories] = useState<TicketCategory[]>(
    [],
  );
  const [ticketCategoriesByType, setTicketCategoriesByType] = useState<
    TicketCategory[]
  >([]);
  const [ticketType, setTicketType] = useState<string>(defaultTicketType);
  const [ticketData, setTicketData] = useState<Ticket>({
    ...defaultTicket,
    buildingId: buildingId ? buildingId : emptyId,
    controlSystemId: controlSystemId ? controlSystemId : emptyId,
    description:
      typeof defaultDescription !== 'undefined' && defaultDescription !== null
        ? defaultDescription
        : '',
    deviceId: deviceId ? deviceId : emptyId,
    keys: isNotNull(keys) ? keys : [],
    partiesInvolved: [
      {
        id: '',
        type: 'Requester',
        status: 'ACTIVE',
        notify: true,
        name: `${userProfile.lastName}, ${userProfile.firstName}`,
        email: userProfile.email,
        phone: userProfile.phoneNumber,
        involvementStart: MIN_DATE_TIME_STRING,
        involvementEnd: MIN_DATE_TIME_STRING,
        createdByType: 'USER',
        createdByName: userProfile.email,
        createdById: userProfile.id,
        keys: [],
      },
    ],
    regionId: regionId ? regionId : emptyId,
    status: 'OPEN',
    summary:
      typeof defaultSummary !== 'undefined' && defaultSummary !== null
        ? defaultSummary
        : '',
    type: defaultTicketType,
    category:
      typeof defaultCategory !== 'undefined' && defaultCategory !== null
        ? defaultCategory
        : '',
    subCategory:
      typeof defaultSubCategory !== 'undefined' && defaultSubCategory !== null
        ? defaultSubCategory
        : '',
    organizationId: userProfile.organization.id,
  });
  const isIB = permissions.internal.hasPermissions(userProfile);
  useEffect(() => {
    if (ticketCategoriesByType !== null) {
      let defaultCategories = [];
      let matchFound = false;
      for (let idx = 0; idx < ticketCategoriesByType.length; idx++) {
        if (ticketCategoriesByType[idx].name === ticketType) {
          matchFound = true;

          setTicketCategories(ticketCategoriesByType[idx].children);

          setTicketData({
            ...ticketData,
            category:
              typeof defaultCategory !== 'undefined' && defaultCategory !== null
                ? defaultCategory
                : '',
            subCategory:
              typeof defaultSubCategory !== 'undefined' &&
              defaultSubCategory !== null
                ? defaultSubCategory
                : '',
          });
          break;
        }
        if (ticketCategoriesByType[idx].name === 'Incident') {
          defaultCategories = ticketCategoriesByType[idx].children;
        }
      }
      if (!matchFound) {
        setTicketCategories(defaultCategories);

        setTicketData({
          ...ticketData,
          category:
            typeof defaultCategory !== 'undefined' && defaultCategory !== null
              ? defaultCategory
              : '',
          subCategory:
            typeof defaultSubCategory !== 'undefined' &&
            defaultSubCategory !== null
              ? defaultSubCategory
              : '',
        });
      }
    }
  }, [ticketCategoriesByType, ticketType]);
  const sendTicket = useCallback(
    async (request: Ticket, siteProjectControlSystemType: string) => {
      if (isSending) {
        return;
      }
      // ONLY FOR "Site Project" TICKETS
      if (
        typeof request !== 'undefined' &&
        request !== null &&
        request.type === 'Site Project' &&
        request.controlSystemId === EMPTY_ID &&
        siteProjectControlSystemType !== ''
      ) {
        request.attributes.push({
          source: 'SiteProject',
          name: 'ControlSystemType',
          dataType: 'string',
          value: siteProjectControlSystemType,
        });
      }
      fetch(`${TICKET_ENDPOINT}`, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getApiToken()}`,
        }),
        body: JSON.stringify(request),
      })
        .then((response) => {
          if (response.status === 200) {
            onClose(true);
          } else {
            message.error('Ticket creation failed!');
          }
        })
        .then(() => {
          setIsSending(false);
        });

      setIsSending(true);
    },
    [isSending],
  );
  const isValid = () => {
    return true;
  };
  const handleSubmit = () => {
    setFormSubmitted(true);
    if (isValid()) {
      sendTicket(ticketData, projectControlSystemType);
    }
  };
  const handleSelectChange = (name: string, value: string) => {
    if (name === 'type') {
      setTicketType(value);
    }
    if (name === 'category') {
      setTicketData({ ...ticketData, [name]: value, subCategory: '' });
    } else {
      setTicketData({ ...ticketData, [name]: value });
    }
  };
  const handleChange = ({
    target: { value, name },
  }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setTicketData({ ...ticketData, [name]: value });
  };
  const handleReferenceChange = (ref: Reference) => {
    setTicketData({
      ...ticketData,
      regionId: ref.regionId,
      buildingId: ref.buildingId,
      controlSystemId: ref.controlSystemId,
    });
  };
  useEffect(() => {
    fetch(`${TICKET_ENDPOINT}/categoriesByType`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: TicketCategory[]) => {
        setTicketCategoriesByType(result);
      });
  }, [getApiToken]);
  const getAvailableSubCategories = () => {
    let subCategories = [];
    if (ticketCategories !== null && ticketCategories.length > 0) {
      ticketCategories.forEach((category) => {
        if (category.name === ticketData.category) {
          subCategories = category.children;
        }
      });
    }
    return subCategories;
  };
  return (
    <Modal
      open={visible}
      onCancel={() => onClose(false)}
      title={<ModalTitle>Create Ticket</ModalTitle>}
      confirmLoading={false}
      width={'40%'}
      footer={
        <ModalFooter>
          <Button onClick={() => onClose(false)}>Close</Button>
          <Button onClick={handleSubmit} type="primary">
            Submit
          </Button>
        </ModalFooter>
      }
    >
      <Form layout="vertical" style={styles.form}>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <FormItem
              label="Ticket Type"
              colon={false}
              style={styles.formItem}
              required
              tooltip={{
                title: (
                  <>
                    <b>Incident:</b> Unplanned interruption or quality reduction
                    of a service.
                    <br />
                    <b>Problem:</b> Underlying cause of one or more incidents.
                    <br />
                    <b>Service Request:</b> Request for information, advice, or
                    a standard service.
                    <br />
                    <b>Change Request:</b> Formal request to modify a service,
                    system, or process.
                    <br />
                    <b>Project:</b> Time-bound initiative with defined
                    deliverables.
                    <br />
                    <b>Site Project:</b> Project scoped to a specific building
                    or site.
                  </>
                ),
              }}
            >
              <Select
                value={ticketData.type}
                onChange={(newValue: string) =>
                  handleSelectChange('type', newValue)
                }
              >
                <Option value="Service Request">Service Request</Option>
                <Option value="Change Request">Change Request</Option>
                <Option value="Incident">Incident</Option>
                <Option value="Problem">Problem</Option>
                {isIB && <Option value="Site Project">Site Project</Option>}
              </Select>
            </FormItem>
            <FormItem
              label="Impact"
              colon={false}
              style={styles.formItem}
              required
              tooltip={{
                title: (
                  <>
                    How broadly this issue affects the business.
                    <br />
                    <b>High:</b> Organization-wide or critical function down.
                    <br />
                    <b>Medium:</b> Department or significant group affected.
                    <br />
                    <b>Low:</b> Single user or non-critical function.
                  </>
                ),
              }}
            >
              <Select
                value={ticketData.impact}
                onChange={(newValue: string) =>
                  handleSelectChange('impact', newValue)
                }
              >
                <Option value="High">High</Option>
                <Option value="Medium">Medium</Option>
                <Option value="Low">Low</Option>
              </Select>
            </FormItem>
            <FormItem
              label="Urgency"
              colon={false}
              style={styles.formItem}
              required
              tooltip={{
                title: (
                  <>
                    How quickly this issue needs to be resolved.
                    <br />
                    <b>High:</b> Immediate action required, no workaround
                    exists.
                    <br />
                    <b>Medium:</b> Timely but not immediate, partial workaround
                    available.
                    <br />
                    <b>Low:</b> No time pressure, workaround exists.
                  </>
                ),
              }}
            >
              <Select
                value={ticketData.urgency}
                onChange={(newValue: string) =>
                  handleSelectChange('urgency', newValue)
                }
              >
                <Option value="High">High</Option>
                <Option value="Medium">Medium</Option>
                <Option value="Low">Low</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem
              label="Category"
              colon={false}
              style={styles.formItem}
              required
              validateStatus={
                formSubmitted === false || ticketData.category !== ''
                  ? 'success'
                  : 'error'
              }
            >
              <Select
                value={ticketData.category}
                onChange={(newValue: string) => {
                  handleSelectChange('category', newValue);
                }}
              >
                <Option value="">--Select--</Option>
                {ticketCategories !== null &&
                  ticketCategories.map((category) => (
                    <Option key={category.name} value={category.name}>
                      {category.name}
                    </Option>
                  ))}
              </Select>
            </FormItem>
            <FormItem
              label="SubCategory"
              colon={false}
              style={styles.formItem}
              required
              validateStatus={
                formSubmitted === false || ticketData.subCategory !== ''
                  ? 'success'
                  : 'error'
              }
            >
              <Select
                value={ticketData.subCategory}
                onChange={(newValue: string) =>
                  handleSelectChange('subCategory', newValue)
                }
              >
                <Option value="">--Select--</Option>
                {ticketCategories !== null &&
                  getAvailableSubCategories().map((subCategory) => (
                    <Option key={subCategory.name} value={subCategory.name}>
                      {subCategory.name}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
          <Col span={8}>
            <ReferencesSelector
              onChanged={handleReferenceChange}
              showRegion={
                typeof regionId === 'undefined' ||
                regionId === null ||
                regionId === emptyId
              }
              showBuilding={
                typeof buildingId === 'undefined' ||
                buildingId === null ||
                buildingId === emptyId
              }
              showControlSystem={
                typeof controlSystemId === 'undefined' ||
                controlSystemId === null ||
                controlSystemId === emptyId
              }
              showOrganization={false}
              references={{
                organizationId: userProfile.organization.id,
                regionId: regionId ? regionId : emptyId,
                buildingId: buildingId ? buildingId : emptyId,
                controlSystemId: controlSystemId ? controlSystemId : emptyId,
              }}
            />
          </Col>
        </Row>
        <Tabs defaultActiveKey="ProblemDescription">
          <Tabs.TabPane
            tab={<b>Problem Description</b>}
            key="ProblemDescription"
          >
            <FormItem
              label="Summary"
              colon={false}
              style={styles.formItem}
              required
              validateStatus={
                formSubmitted === false || ticketData.summary.trim() !== ''
                  ? 'success'
                  : 'error'
              }
            >
              <Input
                name="summary"
                type="text"
                style={styles.summaryInput}
                value={ticketData.summary}
                onChange={handleChange}
                maxLength={50}
              />
            </FormItem>
            <FormItem label="Description" colon={false} style={styles.formItem}>
              <TextArea
                name="description"
                value={ticketData.description}
                onChange={handleChange}
              />
            </FormItem>
          </Tabs.TabPane>
          {ticketType === 'Site Project' &&
            typeof ticketData !== 'undefined' &&
            ticketData.controlSystemId === EMPTY_ID && (
              <Tabs.TabPane
                tab={<b>Control System</b>}
                key="SiteProject.ControlSystem"
              >
                <FormItem
                  label="Control System Type"
                  colon={false}
                  style={styles.formItem}
                  validateStatus={
                    formSubmitted === false || ticketData.summary.trim() !== ''
                      ? 'success'
                      : 'error'
                  }
                >
                  <Select
                    value={projectControlSystemType}
                    onChange={(newValue: string) =>
                      setProjectControlSystemType(newValue)
                    }
                  >
                    {controlSystemTypeOptions.map((option) => {
                      return (
                        <Option key={option.value} value={option.text}>
                          {option.text}
                        </Option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Tabs.TabPane>
            )}
        </Tabs>
      </Form>
    </Modal>
  );
};
export default TicketCreateModal;
